import { createAction } from 'redux-act'

export const setLoading = createAction('Loading Request')



